import { render, staticRenderFns } from "./ConfirmDeleteCompany.vue?vue&type=template&id=72463778&"
import script from "./ConfirmDeleteCompany.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports